/**
 * 外部的SKU、因为下单的逻辑 || 获取SKU等 逻辑不一致、需要单独处理
 *
 * verify_uid : 只有一个UID、「需要校验」
 * not_verify_uid : 只有一个UID、「不需要校验」
 * verify_serverList : 一个UID一个serverList、「需要校验」
 * not_verify_serverList : 一个UID一个serverList、「不需要校验」
 * verify_Input_serverId : 一个UID 输入serverID、「需要校验」
 * not_verify_Input_serverId : 一个UID 输入serverID、「不需要校验」
 * not_handled : 不需要特殊处理
 *
 */
const EXTERNAL_GAMES = {
  verify_uid: ['higgs-domino', 'suasage-man-candies', 'mu-o', 'dragon-raja'],
  not_verify_uid: [
    'freefiremax-diamonds',
    'lords-mobile-diamonds',
    'nsm',
    'bs',
    'coc',
  ],
  verify_serverList: ['lifeafter'],
  not_verify_serverList: [],
  verify_Input_serverId: [],
  not_verify_Input_serverId: ['lr', 'mu-a', 'onmyoji-arena', 'md'],
  not_handled: [],
}

export const EXTERNAL_CHECK_GAMES = EXTERNAL_GAMES['verify_uid']
export const NOT_EXTERNAL_CHECK_GAMES = EXTERNAL_GAMES['not_verify_uid']
export const EXTERNAL_SERVER_CHECK_GAMES = EXTERNAL_GAMES['verify_serverList']
export const NOT_EXTERNAL_SERVER_CHECK_GAMES =
  EXTERNAL_GAMES['not_verify_serverList']
export const EXTERNAL_INPUT_SERVER_GAMES =
  EXTERNAL_GAMES['verify_Input_serverId']
export const NOT_EXTERNAL_INPUT_SERVER_GAMES =
  EXTERNAL_GAMES['not_verify_Input_serverId']

// ! 针对外部的CP、有serverlist 默认会请求serverList
export const GET_EXTERNAL_SERVER_CHECK_GAMES_ALL = ((games) => {
  let arrs = []
  let gs = ['verify_serverList', 'not_verify_serverList']
  for (let k in games) {
    if (gs.includes(k)) {
      arrs = arrs.concat(games[k])
    }
  }
  return arrs
})(EXTERNAL_GAMES)

// ! 针对外部的CP、有serverlist 默认会请求serverList
export const GET_ALL_EXTERNAL_GAMES = ((games) => {
  let arrs = []
  for (let k in games) {
    arrs = arrs.concat(games[k])
  }
  return arrs
})(EXTERNAL_GAMES)

/***********************************************************************外部SKU的处理End**************************************************************************************************************************/

// 下单时需要登录的游戏
export const createdOrderNeedLoginGames = ['lordsmobile', 'pubgm']
// sku按照列展示的游戏
export const skuDisplayColumnOfGames = ['state-of-survival']
// sku是否横向展示
export const skuDisplayScrollXOfGames = ['lordsmobile', 'pubgm']
// skulist通过用户uid校验接口返回的游戏
export const getSkuListFromUidValidatorsGames = ['state-of-survival']
// 需要显示nick name的游戏
export const displayNickNameOfGames = ['state-of-survival']
// 需要显示server的游戏
export const displayServerOfGames = ['infinity-war']
// uid检验成功后,需要显示绿色图标的游戏
export const displayGreenByUidSuccessOfGames = []
export const TopLupe_WalletName = 'T-Wallet'
export const gameTopLupe = 'toplupe'

// [" razer " 雷蛇平台]的游戏、界面长得一样、同时交互逻辑也一致
export const RAZER_GAMES = [
  'psn',
  'roblox',
  'xbox-live',
  'discord',
  'ea-play',
  'hulu',
  'minecraft',
  'steam',
  'xbox',
  'nintendo',
  'tinder',
]

// 并行请求的游戏列表需要单独处理
export const PARALLEL_REQUESTS_GAMES = ['puzzles-survival', 'soul-land3d']

// vpn的两个CP 单独处理
export const VPN_GAMES = ['turbo-vpn', 'vpn-proxy-master']

// 需要兑换的游戏
export const exchangeGames = ['pubgm', 'lordsmobile']

// bottom-tips 写入动态配置折扣
export const gameDiscounts = {
  'turbo-vpn': '5%',
  'vpn-proxy-master': '5%',
  'game-of-khans': '5%',
  'kungfu-legend': '5%',
  'star-maker': '5%',
}

// 渲染新模板、新逻辑 全部的CP （ALL）
export const RENDER_TEMP = [
  'call-me-emperor',
  'pubgm',
  'pubgm-dc',
  'lordsmobile',
  'state-of-survival',
  'hago',
  'shining-nikki',
  'star-maker',
  'mobile-legends',
  'game-of-khans',
  'game-of-sultans',
  'guardians-of-cloudia',
  'dragonheir',
  'kungfu-legend',
  'infinity-kingdom',
  'infinity-war',
  'undawn',
  'hok',
  'arena-breakout',
  'genshin',
  'genshin-en',
  'dummy-product',
  'goddess-of-victory-nikke',
  'freefire-diamonds',
  'honkai-star-rail',
  'zenless-zone-zero',
  'eggy-party',
  'arena-breakout-dc',
  'lvzhou',
  'whiteout-survival',
  'zepeto',
  ...PARALLEL_REQUESTS_GAMES,
  ...GET_ALL_EXTERNAL_GAMES,
  ...VPN_GAMES,
  ...RAZER_GAMES,
]

// 输入框可以输入任何字符
export const ENTER_ANY_GAMES = [
  'kungfu-legend',
  'guardians-of-cloudia',
  'dragonheir',
  'state-of-survival',
  'zepeto',
  ...EXTERNAL_CHECK_GAMES,
  ...EXTERNAL_SERVER_CHECK_GAMES,
]

// 默认请求服务器接口
export const IS_GAME_SERVER = [
  'guardians-of-cloudia',
  'dragonheir',
  'genshin',
  'genshin-en',
  'dummy-product',
  'goddess-of-victory-nikke',
  'honkai-star-rail',
  'zenless-zone-zero',
  'eggy-party',
  'arena-breakout-dc',
  'kungfu-legend',
  ...VPN_GAMES,
]

// 处理了弱网情况的游戏
export const GAME_BY_WEAKNET_WORK = [...exchangeGames, ...RENDER_TEMP]

// code 模式维护的游戏列表【特殊处理】
export const CODE_MODEL_GAME_LIST = [
  'undawn',
  'hok',
  'arena-breakout',
  ...exchangeGames,
  ...RAZER_GAMES,
]

export const getallexternal = () => EXTERNAL_GAMES.map((item) => item.games)
